import { Component, inject, Input } from '@angular/core';
import { Signal } from '../types';
import { ColoredChipListComponent } from '../../../shared/components/colored-chip-list/colored-chip-list.component';
import { ColoredChip } from '../../../shared/types/common';
import { CopilotService } from '../../../services/copilot.service';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { NgIf } from '@angular/common';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-signal-card',
  imports: [
    ColoredChipListComponent,
    AssetVersionPipe,
  ],
  templateUrl: './signal-card.component.html',
  styleUrl: './signal-card.component.scss'
})
export class SignalCardComponent {

  @Input() signalData!: Signal;
  @Input() extraText = '';

  private copilotService = inject(CopilotService);

  get coloredChipList(): ColoredChip[]  {
    return this.signalData?.tags.map(item => ({
      text: item,
      color: "#4E5258",
      borderColor: "#CDD1D7",
      backgroundColor: "#FFFFFF"
    })) || [];
  }

  protected onSendMessage(): void {
    this.copilotService.triggerMessage('Please elaborate on this signal. Explain what data supports it and what should I do to reach the expected impact.', { signal: this.signalData });
  }

}
